import { render, staticRenderFns } from "./CustomerPaymentInfo.vue?vue&type=template&id=dca08098&lang=pug&"
import script from "./CustomerPaymentInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerPaymentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports